<template>
	<div class="auth">
		<div class="box">
			<div class="header">
				<img src="@/assets/images/logo-small.png"/>
				<div class="text">Forhandler login</div>
			</div>

			<div class="form">
				<slot/>
			</div>
		</div>
	</div>
</template>

<script>
export default {

};
</script>

<style lang="scss" scoped>
.auth {
	padding-top: em(139);

	display: flex;
	flex-direction: column;
	align-items: center;

	.box {
		background-color: $white1;
		width: 100%;
		max-width: em(376);
		padding: em(26);

		display: flex;
		flex-direction: column;
		align-items: center;

		.header {
			text-align: center;
			margin-top: 2em;
			margin-bottom: 4em;
			width: em(145);

			img {
				display: block;
				margin-bottom: 0.5em;
			}

			.text {
				font-size: 12px;
			}
		}

		.form {
			width: 100%;

			.forgot {
				display: block;
				text-align: center;
				margin-top: 2em;
				color: #007ACE;
				text-decoration: underline;
				font-size: 13px;
			}
		}
	}
}
</style>
